import { OTP_FAILURE_REASONS, type OtpFailureReason } from 'app/tracking/events'

export type OtpAttemptFailureClassification = {
    reason: OtpFailureReason
    errorCode?: string
}

function extractClerkErrorCode(error: unknown): string | undefined {
    if (!error || typeof error !== 'object') {
        return undefined
    }

    const errors = (error as { errors?: unknown }).errors
    if (!Array.isArray(errors) || errors.length === 0) {
        return undefined
    }

    const code = (errors[0] as { code?: unknown } | undefined)?.code
    return typeof code === 'string' && code.length > 0 ? code : undefined
}

function extractClerkStatus(error: unknown): number | undefined {
    if (!error || typeof error !== 'object') {
        return undefined
    }

    const status = (error as { status?: unknown }).status
    return typeof status === 'number' ? status : undefined
}

/**
 * Maps a Clerk attemptFirstFactor rejection to a controlled otp_failed reason.
 * Preserves the raw Clerk error code for PostHog (no PII).
 */
export function classifyClerkOtpAttemptFailure(error: unknown): OtpAttemptFailureClassification {
    const errorCode = extractClerkErrorCode(error)
    const status = extractClerkStatus(error)

    if (status === 429 || errorCode === 'verification_code_too_many_requests') {
        return { reason: OTP_FAILURE_REASONS.RATE_LIMITED, errorCode }
    }

    switch (errorCode) {
        case 'form_code_incorrect':
            return { reason: OTP_FAILURE_REASONS.INCORRECT_CODE, errorCode }
        case 'verification_expired':
            return { reason: OTP_FAILURE_REASONS.EXPIRED_CODE, errorCode }
        case 'verification_failed':
            return { reason: OTP_FAILURE_REASONS.TOO_MANY_ATTEMPTS, errorCode }
        case 'verification_missing':
        case 'verification_not_sent':
            return { reason: OTP_FAILURE_REASONS.NO_SIGN_IN, errorCode }
        default:
            return { reason: OTP_FAILURE_REASONS.UNKNOWN, errorCode }
    }
}
